import { memo } from 'react';
import FloatingMenu from '../widgets/FloatingMenu';
import { BoldButton, InlineCodeButton, ItalicButton, StrikethroughButton } from './buttons/format';
import { FormulaMarkButton } from './buttons/formula';
import { ReviewerCopilotButton } from './buttons/copilot';
import { useCurrentEditor } from '@tiptap/react';

interface MarkdownFloatingMenuProps {
  enableMath?: boolean;
}

function MarkdownFloatingMenu({ enableMath = false }: MarkdownFloatingMenuProps) {
  const { editor } = useCurrentEditor();
  if (!editor) return null;

  return (
    <>
      <FloatingMenu
        name="ReadOnlyFloatingMenu"
        shouldShow={({ editor }) => !editor.isEditable && !editor.state.selection.empty}
      >
        <ReviewerCopilotButton />
      </FloatingMenu>
      <FloatingMenu
        name="EditableFloatingMenu"
        shouldShow={({ editor }) => editor.isEditable && !editor.state.selection.empty}
      >
        <BoldButton />
        <ItalicButton />
        <StrikethroughButton />
        <InlineCodeButton />
        {enableMath && <FormulaMarkButton />}
        <ReviewerCopilotButton />
      </FloatingMenu>
    </>
  );
}

export default memo(MarkdownFloatingMenu);
